import React from 'react';
import PropTypes from 'prop-types';
import { ExpiryAlertIcon } from './ExpiryAlertIcon';
import { VALIDITY_STATUS } from '../../../helpers/ExpiryRule';

const ALERT_TEXT = Object.freeze({
	[VALIDITY_STATUS.EXPIRING]: 'One or more add-ons are expiring',
	[VALIDITY_STATUS.EXPIRED]: 'One or more add-ons have expired',
});

// The Add-ons column only ever shows an alert, never a list of add-ons or their dates (SYN-3101 AC 9).
export const AddonsAlertCell = ({ alert, onClick }) => {
	if (!alert) {
		return null;
	}

	return <ExpiryAlertIcon status={alert} text={ALERT_TEXT[alert]} onClick={onClick} />;
};

AddonsAlertCell.propTypes = {
	alert: PropTypes.oneOf([VALIDITY_STATUS.EXPIRING, VALIDITY_STATUS.EXPIRED]),
	onClick: PropTypes.func,
};

AddonsAlertCell.defaultProps = {
	alert: null,
};
